import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/button';
import { ArrowRight, Phone } from 'lucide-react';

export const FinalCTA = ({ onOpenQuiz }) => {
  return (
    <section className="py-32 sm:py-40 bg-gradient-to-b from-[#0F0F13] to-[#050505]">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="space-y-8"
        >
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-headline font-bold text-[#F4F4F5] leading-tight">
            Ready to grow without the{' '}
            <span className="gradient-text">office overhead?</span>
          </h2>

          <p className="text-xl text-[#A1A1AA] font-body max-w-2xl mx-auto leading-relaxed">
            Do not let another lead go to voicemail. Let us put your office on autopilot.
          </p>

          <div className="pt-6">
            <Button
              onClick={onOpenQuiz}
              size="lg"
              className="bg-[#00E599] hover:bg-[#00C985] text-[#050505] whitespace-nowrap w-full sm:w-auto px-5 sm:px-12 py-5 sm:py-7 text-sm sm:text-2xl font-body font-bold transition-all duration-300 hover:shadow-2xl hover:shadow-[#00E599]/50 hover:scale-105 rounded-xl inline-flex items-center justify-center gap-2 sm:gap-3"
            >
              Book My Strategy Call
              <ArrowRight className="w-5 h-5 sm:w-6 sm:h-6 shrink-0" />
            </Button>
          </div>

          <p className="text-sm text-[#A1A1AA] font-body italic max-w-xl mx-auto">
            No pressure. Just a look at how much revenue you are leaving on the table.
          </p>

          <div className="pt-8">
            <p className="text-lg text-[#A1A1AA] font-body mb-3">Or call us directly:</p>
            <a 
              href="tel:6027306385"
              className="inline-flex items-center gap-3 text-3xl font-headline font-bold gradient-text hover:opacity-80 transition-opacity"
            >
              <Phone className="w-8 h-8" />
              (602) 730-6385
            </a>
            <p className="text-sm text-[#A1A1AA] font-body italic mt-2">
              We answer. Ironic if we did not.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
